/** Brand tokens from https://theqwikfix.com */
export const QWIKFIX_BRAND = {
  navy: '#01445A',
  navyDark: '#00394d',
  cyan: '#42b9db',
  cyanBright: '#2aa2cc',
  cyanDeep: '#027B9F',
  cyanLight: '#02A1CF',
  cardGradient:
    'linear-gradient(135deg, #01445A 0%, #00394d 55%, #002f3f 100%)',
  cardGradientLight:
    'linear-gradient(160deg, #f8fbfd 0%, #eef6fa 45%, #f0f2f6 100%)',
  buttonGradient: 'linear-gradient(180deg, #02A1CF 0%, #027B9F 100%)',
  glowCyan: 'rgba(66, 185, 219, 0.35)',
  glowBright: 'rgba(42, 162, 204, 0.22)',
} as const;

export const QWIKFIX_LOGO_LIGHT_SRC = '/brand/qwikfix-logo-light.svg';
export const QWIKFIX_LOGO_DARK_SRC = '/brand/qwikfix-logo-dark.svg';
export const QWIKFIX_WEBSITE_URL = 'https://theqwikfix.com/';
